import type { QueryClient } from "@tanstack/react-query";
import { WaiversPoliciesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchPoliciesGet(
  queryClient: QueryClient,
  page: number = 1,
  pageSize: number = 1000,
  lastSelectedId?: number | null,
  active?: boolean | null,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching policies");
  }

  const service = createAuthenticatedApi(WaiversPoliciesApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Waivers, "admin", page, pageSize, lastSelectedId, active],
    queryFn: () =>
      service.apiPoliciesScrollGet({
        page,
        pageSize,
        lastSelectedId: lastSelectedId ?? undefined,
        active: active ?? undefined,
      }),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}

